"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _manager = require("../../constants/manager");
var _lodash = _interopRequireDefault(require("lodash.set"));
var _lodash2 = _interopRequireDefault(require("lodash.get"));
var _utils = require("./utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function listener(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    type = _ref2[0],
    payload = _ref2[1];
  switch (type) {
    case _manager.UPDATE:
      {
        var buildNumber = payload.buildNumber,
          user = payload.user,
          path = payload.path,
          data = payload.data,
          digitalData = payload.digitalData,
          updatedUserDetails = payload.updatedUserDetails,
          experimentIds = payload.experimentIds,
          cart = payload.cart;
        if (buildNumber) {
          (0, _lodash.default)(window, 'digitalData.page.attributes.buildNumber', "ODP:".concat(payload.buildNumber));
        }
        if (experimentIds) {
          (0, _lodash.default)(window, 'digitalData.experimentIds', experimentIds);
        }
        if (user) {
          (0, _lodash.default)(window, 'digitalData.user', payload.user);
        }
        if (cart) {
          (0, _lodash.default)(window, "digitalData.cart", cart);
        }
        if (digitalData) {
          (0, _lodash.default)(window, "digitalData.page.pageInfo.pageId", digitalData.pageId);
          (0, _lodash.default)(window, "digitalData.page.pageInfo.pageName", digitalData.pageName);
          (0, _lodash.default)(window, "digitalData.page.pageInfo.pageType", digitalData.pageType);
          (0, _lodash.default)(window, "digitalData.page.pageInfo.onsiteSearchTerm", digitalData.onsiteSearchTerm);
          (0, _lodash.default)(window, "digitalData.page.pageInfo.onsiteSearchResults", digitalData.onsiteSearchResults);
          (0, _lodash.default)(window, "digitalData.page.pageInfo.isSearchSystemGenerated", digitalData.isSearchSystemGenerated);
          (0, _lodash.default)(window, "digitalData.page.pageInfo.attributes.rawPageName", digitalData.rawPageName);
          (0, _lodash.default)(window, "digitalData.page.pageInfo.url", digitalData.url);
          (0, _lodash.default)("product", Array.isArray(digitalData.product) ? digitalData.product : (0, _lodash2.default)(window, 'digitalData.product', []));
          (0, _lodash.default)(window, "digitalData.products", digitalData.products);
          (0, _lodash.default)(window, "digitalData.page.attributes", _objectSpread({}, (0, _lodash2.default)(window, 'digitalData.page.attributes', {}), digitalData.additionalAttributes));
          (0, _lodash.default)(window, "digitalData.page.attributes.environment", digitalData.environment || 'ODP');
          (0, _lodash.default)(window, "digitalData.page.category.primaryCategory", digitalData.primaryCategory);
          (0, _lodash.default)(window, "digitalData.page.category.subCategory1", digitalData.subCategory1);
          (0, _lodash.default)(window, "digitalData.page.category.subCategory2", digitalData.subCategory2);
          (0, _lodash.default)(window, "digitalData.page.category.subCategory3", digitalData.subCategory3);
          (0, _lodash.default)(window, "digitalData.product.0.productInfo.productID", digitalData.productID);
          (0, _lodash.default)(window, "digitalData.productFindingMethod", digitalData.productFindingMethod);
          (0, _lodash.default)(window, "digitalData.product.0.productInfo.dinkus", digitalData.dinkus);
          (0, _lodash.default)(window, "digitalData.product.0.productInfo.rating", digitalData.rating);
          (0, _lodash.default)(window, "digitalData.product.0.productInfo.isEarlyAccessProduct", digitalData.isEarlyAccessProduct);
          (0, _lodash.default)(window, "digitalData.product.0.attributes.webHierarchy", digitalData.webHierarchy);
          (0, _lodash.default)(window, "digitalData.product.0.attributes.has2hrCnCBadgeOn", digitalData.has2hrCnCBadgeOn);
          (0, _lodash.default)(window, "digitalData.latestQuery", digitalData.latestQuery);
          (0, _lodash.default)(window, "digitalData.refineFilter", digitalData.refineFilter);
        }
        if (updatedUserDetails) {
          var keys = Object.keys(updatedUserDetails);
          for (var key in keys) {
            (0, _lodash.default)(window, "digitalData.user.".concat(keys[key]), updatedUserDetails[keys[key]]);
          }
        }
        if (path && data) {
          (0, _lodash.default)(window, "digitalData.".concat(path), data);
        }
        break;
      }
    case _manager.EVENT:
      {
        var name = payload.name,
          _data = payload.data;
        switch (name) {
          case _manager.events.PAGE_VIEW:
            window._satellite.track('page-view');
            if (!this.pageBottomIsFired) {
              window._satellite.pageBottom();
              this.pageBottomIsFired = true;
            }
            break;
          default:
            (0, _utils.dispatchAnalyticsDomEvent)({
              name: name,
              data: _data
            });
            break;
        }
        break;
      }
    default:
      break;
  }
}
var _default = listener;
exports.default = _default;